// Module-level currency symbol, set once business info loads
let _symbol = '\u00A3'; // default £

export const SUPPORTED_CURRENCIES = [
  { code: 'GBP', symbol: '\u00A3', label: 'GBP (\u00A3) \u2014 British Pound' },
  { code: 'USD', symbol: '$', label: 'USD ($) \u2014 US Dollar' },
  { code: 'EUR', symbol: '\u20AC', label: 'EUR (\u20AC) \u2014 Euro' },
  { code: 'AUD', symbol: 'A$', label: 'AUD (A$) \u2014 Australian Dollar' },
];

export function setCurrency(symbol) {
  if (symbol && typeof symbol === 'string') _symbol = symbol;
}

export function getCurrencySymbol() {
  return _symbol;
}

// Drop-in replacement for `£${x}` -> `${money(x)}`
export function money(amount) {
  const n = Number(amount) || 0;
  return `${_symbol}${n.toFixed(n % 1 === 0 ? 0 : 2)}`;
}

// When you want fixed 2 decimals (for invoices / totals)
export function money2(amount) {
  const n = Number(amount) || 0;
  return `${_symbol}${n.toFixed(2)}`;
}
